import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide4: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            The B-52's <span>-</span>
            <br /> Legal Tender
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=mBRr_TqLDf4"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Duda Leite</S.Name>
          <S.Profile>
            Jornalista, cineasta e curador do m-v-f- (Music Video Festival)
          </S.Profile>
          <S.Text>
            “O videoclipe pop que mais me marcou foi ‘Legal tender’, dos The
            B-52’s, com aquela estética ultracolorida da new wave e o cabelo
            ‘bolo de noiva’ das cantoras. ‘Whip it’, do Devo, me fisgou pela
            estranheza daqueles homens vestidos com regata e bermuda e o icônico
            chapéu vermelho. Além disso, o clipe tinha um clima S&M que me
            deixava bastante intrigado.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
